export default "__VITE_ASSET__BhlGhgdV__"